module.exports = __webpack_public_path__ + "static/media/store.c5470e3e.png";